// extracted by mini-css-extract-plugin
export default {"root":"NCclm2AHeY","row":"AIe2gc0s0y","row_twoColumnBigLeft":"KsIA0eoFNT","row_twoColumnBigRight":"INs3Dn6Rd6","stackedColumns":"btd8ZLl6Y9","column":"KTx1t2Xxjq"};